/* eslint-disable */
import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

// import css
import styles from './IDTFRecordingInfoPane.css';
import { Interpretations } from './Interpretations/Interpretations';
import { ACUITY_MAP } from '../Common/Table/Constants/Constants';
import { getKardiaRxEcgTableData } from '../../state/kardiaRxIdtf/KardiaRxIDTFEcgTableActions';

const IDTFRecordingInfoPane = props => {
  useEffect(() => {
    props.getKardiaRxEcgTableData(props.match.params.idtf_connection_id);
  }, []);

  const { recordingsList } = props;

  const rec = recordingsList && recordingsList.recordings && recordingsList.recordings.data[0] && recordingsList.recordings.data[0].filter((item)=> item.recordingId === props.selectedRecordingId)
  const selectedRecording = rec && rec.length ? rec[0] : {}
  return (
    <div>
      <h2>Event Details</h2>
      <div className={styles.infoPaneWrapper}>
        <div>
          {/* Inline style should be reomoved after interpretation addition */}
          <div className={styles.paneText}>INTERPRETATION:</div>
          <span className={styles.paneValues}>
            <Interpretations data={selectedRecording} />
          </span>
        </div>
        <div>
          <div className={styles.paneText}>ACUITY:</div>
          <div className={styles.paneValues}>
            {ACUITY_MAP[selectedRecording && selectedRecording.acuity]}
          </div>
        </div>
        <div>
          <div className={styles.paneText}>SYMPTOMS:</div>
          <div className={styles.paneValues}>
            {selectedRecording && selectedRecording.symptoms}
          </div>
        </div>
        <div>
          <div className={styles.paneText}>ACTIVITY:</div>
          <div className={styles.paneValues}>
            {selectedRecording && selectedRecording.activities}
          </div>
        </div>
        <div>
          <div className={styles.paneText}>INCIDENTAL FINDINGS:</div>
          <div className={styles.paneValues}>
            {selectedRecording && selectedRecording.incidentalFindings}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const recordingsList = state.kardiaRx.kardiaRxIDTFEcg;
  return { recordingsList };
};

const mapActionCreators = {
  getKardiaRxEcgTableData,
};

export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(IDTFRecordingInfoPane));



// WEBPACK FOOTER //
// ./src/views/components/IDTFRecordingInfoPane/IDTFRecordingInfoPane.jsx